import { CaretIcon } from "../Icons/Icons";

interface Props {
    outsideIndex: number;
    setOutsideIndex: React.Dispatch<React.SetStateAction<number>>;
    outsideNames: string[]
}

const OutsidePagination: React.FC<Props> = ({ outsideIndex, outsideNames, setOutsideIndex}) => {

    const prevOutside = () => {
        const prevIndex = (outsideIndex - 1 + outsideNames.length) % outsideNames.length;
        setOutsideIndex(prevIndex);
    }

    const nextOutside = () => {
        const nextIndex = (outsideIndex + 1) % outsideNames.length;
        setOutsideIndex(nextIndex);
    }

    return (
        <div aria-label="outside-pagination"
             className="flex justify-center items-center p-4">
            <div className="flex justify-center items-center gap-4">
                <button onClick={prevOutside}
                        className="pagination-button">
                    <CaretIcon className="-rotate-90 size-5"/>
                </button>
                <div className="flex flex-row gap-4">
                {
                    outsideNames.map((name, index) => (
                        <button key={index}
                                className={`${ outsideIndex === index ? "pagination-button-active" : "pagination-button-inactive" }`}
                                onClick={() => setOutsideIndex(index)}>
                            { name }
                        </button>
                    ))
                }
                </div>
                <button onClick={nextOutside}
                        className="pagination-button">
                    <CaretIcon className="rotate-90 size-5"/>
                </button>
            </div>
        </div>
    )
}

export default OutsidePagination;
